<div class="loading-category-wrapper {{loadingWrapperClass}}">
    <Icon [type]="'loading'" size="lg" *ngIf="!isInSSRMode"></Icon>
    <span class="mx-3 mt-3 spinner-border text-primary" style="color: var(--btn2-bg-color);" *ngIf="isInSSRMode"></span>
    <div class="loading-text mb-2" *ngIf="loadingText" style="padding-left: 0;">
        {{loadingText}}</div>
    <div class="loading-text mb-2" *ngIf="!loadingText" [appTranslate]="'GENERAL.LOADING'" style="padding-left: 0;">
        加载中...</div>
</div>